<template>
  <div class="article-list">
    <section v-for="(article) in articles" class="article-list__item list-item" :key="article.id">
      <h1 class="list-item__title">{{article.title}}</h1>
      <img
        :width="article.image.width"
        :height="article.image.height"
        class="list-item__image"
        :src="article.image.url">
      <div ref="content" class="list-item__content" v-html="article.content"></div>
    </section>
  </div>
</template>

<script type="text/babel">
import { cloneDeep } from 'lodash';

export default {
  props: {
    value: {
      required: true,
    },
    max: {
      default: 5,
      type: Number,
    },
  },
  computed: {
    articles() {
      const articles = cloneDeep(this.value);
      return articles.slice(0, this.max).map((article) => {
        const articlePrepared = article;
        if (articlePrepared.image) {
          articlePrepared.image.url = this.$helpers.getThumbnail(articlePrepared.image, 500);
        }
        return articlePrepared;
      });
    },
  },
  methods: {
    checkOverflow() {
      if (this.$refs.content) {
        this.$refs.content.forEach((el) => {
          el.classList.toggle('list-item__content--overflow', el.scrollHeight > el.clientHeight);
        });
      }
    },
  },
  created() {
    window.addEventListener('resize', () => {
      this.checkOverflow();
    });
  },
  mounted() {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.checkOverflow();
      });
    });
  },
};
</script>

<style lang="scss" scoped>
  .article-list {
    display: grid;
    height: 100%;
    grid-auto-columns: 1fr;
    grid-template-rows: max-content max-content minmax(0, 1fr);
    grid-gap: 0 .5em;
    min-height: 0;
  }
  .list-item {
    display: contents;
    @for $i from 1 through 6 {
      &:nth-child(#{$i}) > * {
        grid-column: $i;
        @for $j from 1 through 6 {
          &:nth-child(#{$j}) {
            grid-row: $j;
          }
        }
      }
    }
    &__image {
      width: 100%;
      height: auto;
      margin: auto;
    }
    &__title {
      color: #fff;
      text-shadow: 0 0 15px #0002, 0 0 2px #0001;
      text-align: center;
      font-size: 2em;
      z-index: 2;
      background: linear-gradient(45deg, var(--gradient-color-1), var(--gradient-color-2));
      padding: 1em 0.5em;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &__content {
      position: relative;
      font-size: 1.5em;
      &--overflow {
        &:after {
          content: '';
          display: block;
          top: 0;
          left: 0;
          right:  0;
          bottom:  0;
          position:  absolute;
          background: linear-gradient(to top, #fff, rgba(255,255,255,0) 20%);
        }
      }
    }
  }
</style>
